__turbopack_context__.v({
  "blocksBackgroundColor": "OverlayComponent-module-scss-module___SDQsW__blocksBackgroundColor",
  "blocksFontColor": "OverlayComponent-module-scss-module___SDQsW__blocksFontColor",
  "footer": "OverlayComponent-module-scss-module___SDQsW__footer",
  "message": "OverlayComponent-module-scss-module___SDQsW__message",
  "overlay": "OverlayComponent-module-scss-module___SDQsW__overlay",
  "secondaryNavBackgroundColor": "OverlayComponent-module-scss-module___SDQsW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "OverlayComponent-module-scss-module___SDQsW__themeBackgroundColor",
  "themeFontColor": "OverlayComponent-module-scss-module___SDQsW__themeFontColor",
});
